/* MysticBluuMoon: Etsy-style cart reminder toast.
   Shows once per session when the cart has items: photo of the first item,
   sale price + % off when the item has a compare-at discount, subtotal,
   and a button that opens the cart drawer. Dismissible; remembers dismissal
   for the session. */
(function () {
  if (sessionStorage.getItem('mbmCartToastDismissed')) return;
  if (window.location.pathname.indexOf('/cart') === 0 || window.location.pathname.indexOf('/checkout') === 0) return;

  var money = function (cents) { return '$' + (cents / 100).toFixed(2); };

  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      if (!cart.items || cart.items.length === 0) return;
      var item = cart.items[0];

      // Check the item's variant for a compare-at sale price
      fetch('/products/' + item.handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (product) {
          var variant = null;
          product.variants.forEach(function (v) { if (v.id === item.variant_id) variant = v; });
          var onSale = variant && variant.compare_at_price && variant.compare_at_price > variant.price;
          render(cart, item, variant, onSale);
        })
        .catch(function () { render(cart, item, null, false); });
    })
    .catch(function () { /* no cart, no toast */ });

  function render(cart, item, variant, onSale) {
    var headline = onSale ? 'Save on an item in your cart!' : 'Still thinking it over?';
    var priceHtml = '';
    if (onSale) {
      var pct = Math.round((1 - variant.price / variant.compare_at_price) * 100);
      priceHtml = '<strong>' + money(variant.price) + '</strong> <s style="opacity:0.6;">' + money(variant.compare_at_price) + '</s> <span class="mbm-toast-off">' + pct + '% off</span>';
    } else {
      priceHtml = '<strong>' + money(item.final_line_price / item.quantity) + '</strong>';
    }

    var toast = document.createElement('div');
    toast.className = 'mbm-cart-toast';
    toast.setAttribute('role', 'status');
    toast.innerHTML =
      '<button type="button" class="mbm-toast-close" aria-label="Dismiss cart reminder">\u00d7</button>' +
      '<div class="mbm-toast-row">' +
        (item.image ? '<img src="' + item.image + '&width=120" alt="" class="mbm-toast-img" loading="lazy">' : '') +
        '<div>' +
          '<div class="mbm-toast-headline">' + headline + '</div>' +
          '<div class="mbm-toast-price">' + priceHtml + '</div>' +
          '<div class="mbm-toast-sub">Subtotal: <strong>' + money(cart.total_price) + '</strong></div>' +
        '</div>' +
      '</div>' +
      '<button type="button" class="mbm-toast-cta">View cart &amp; check out \u2192</button>';

    document.body.appendChild(toast);
    requestAnimationFrame(function () { toast.classList.add('mbm-toast-show'); });

    toast.querySelector('.mbm-toast-close').addEventListener('click', function () {
      toast.remove();
      sessionStorage.setItem('mbmCartToastDismissed', '1');
    });

    toast.querySelector('.mbm-toast-cta').addEventListener('click', function () {
      // Open the cart drawer via the header cart link; fall back to the cart page
      var cartLink = document.querySelector('a[href="/cart"]');
      if (cartLink) { cartLink.click(); } else { window.location.href = '/cart'; }
    });
  }
})();
